var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.937 4.769H3.062A2.54 2.54 0 0 0 .525 7.306v13.432a2.54 2.54 0 0 0 2.537 2.537h21.875a2.54 2.54 0 0 0 2.538-2.537V7.306a2.54 2.54 0 0 0-2.538-2.537Zm0 1.531a.88.88 0 0 1 .57.175l-10.895 6.606a1.225 1.225 0 0 1-1.225 0L2.494 6.475c.175-.088.35-.175.568-.175h21.875Zm0 15.4H3.062a1.018 1.018 0 0 1-1.006-1.006V8.006l10.5 6.388a2.72 2.72 0 0 0 1.4.393c.481 0 .963-.13 1.4-.393l10.5-6.388v12.688c.088.569-.394 1.006-.919 1.006Z",
    fill: "#292723",
    opacity: 0.6
  })));
};
export default SvgEnvelope;